export default "__VITE_ASSET__Voo3Fhgh__"